/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */

import EDC from '../../../shared/globals';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.PiratesMatchText.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.PiratesMatchText.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.sentence = null;
  this.choices = [];
};

EDC.Games.PiratesMatchText.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.PiratesMatchText.Scenes.Main.prototype.constructor = EDC.Games.PiratesMatchText.Scenes.Main;

const PMT = EDC.Games.PiratesMatchText.Scenes.Main.prototype;

PMT.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

PMT.createTemplateUI = function () {
  const title = this.add.sprite(235, 550, 'title');
  const instructions = this.add.sprite(this.game.config.width / 2, 1000, 'instructions').setOrigin(0.5);
  const scroll = this.add.sprite(this.game.config.width / 2, 360, 'scroll').setOrigin(0.5);
  const flag = this.add.sprite(1630, 860, 'flag').setOrigin(0, 1);
  this.flagAnimation(flag);
};

PMT.loadIteration = function () {
  this.createQuestion();
  this.createChoices();
};

PMT.createChoices = function () {
  const { choicesText } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { correctAnswer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const font = {
    font: '85px Arial',
    fill: 'yellow',
    stroke: 'brown',
    strokeThickness: 12,
  };

  for (let i = 0; i < choicesText.length; i++) {
    const container = this.add.container(0, 0);
    const chest = this.add.sprite(0, 50, 'chest-closed');
    const item = this.add.text(0, chest.displayHeight - 60, choicesText[i], font).setOrigin(0.5);
    container.add(chest);
    container.add(item);
    container.y = -300;
    container.x = 560 + i * 400;
    container.setSize(chest.displayWidth, chest.displayHeight + item.displayHeight);
    container.setInteractive();
    this.tweens.add({
      targets: container,
      y: 735,
      ease: 'Bounce',
      duration: 500,
      delay: 100,
    });
    this.cursorManager.setDefaultDraggableEvents(container);
    container.on('pointerup', this.checkAnswer.bind(this, container), this);
    this.choices.push(container);
  }
  this.choices[correctAnswer - 1].isCorrect = true;
};

PMT.createQuestion = function () {
  const { sentenceText } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const sentence = this.make.text({
    x: this.game.config.width / 2,
    y: 360,
    text: sentenceText,
    origin: { x: 0.5, y: 0.5 },
    style: {
      font: '60px Arial',
      fill: 'yellow',
      stroke: 'brown',
      strokeThickness: 12,
      wordWrap: { width: 800 },
      lineSpacing: 8,
    },
  });
  this.sentence = sentence;
};

PMT.flagAnimation = function (flag) {
  const randomAngle = 1 + Math.floor(Math.random() * 3);
  const randomDuration = 650 + Math.floor(Math.random() * 300);
  this.tweens.add({
    targets: flag,
    angle: flag.angle - randomAngle,
    duration: randomDuration,
    ease: 'Sine.easeInOut',
    yoyo: true,
    onComplete: this.flagAnimation.bind(this, flag),
  });
};

PMT.openChest = function (container, isCorrect) {
  if (isCorrect) {
    if (this.difficulty > 1) {
      container.first.setTexture('chest-gem');
    } else {
      container.first.setTexture('chest-coin');
    }
  } else {
    this.tweens.add({
      targets: container,
      x: container.x - 10,
      duration: 30,
      ease: 'Linear',
      repeat: 3,
      yoyo: true,
    });
    container.first.setTexture('chest-open');
  }
};

PMT.checkAnswer = function (container) {
  if (container.isCorrect) {
    this.playCorrect();
    this.openChest(container, true);
    this.choices.map((x) => {
      x.disableInteractive();
    });
    this.time.delayedCall(2500, this.shrinkAnimation, [], this);
  } else {
    this.openChest(container, false);
    this.playWrong();
    container.disableInteractive();
  }
};

PMT.shrinkAnimation = function () {
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.choices.map((x) => {
      this.tweens.add({
        targets: x,
        scaleX: '+=0.2',
        scaleY: '+=0.2',
        duration: 300,
        ease: 'Sine.easeInOut',
        yoyo: false,
      });
      this.tweens.add({
        targets: x,
        scaleX: 0,
        scaleY: 0,
        duration: 500,
        delay: 300,
        ease: 'Sine.easeInOut',
        yoyo: false,
      });
    });
    this.time.delayedCall(1100, this.nextIteration, [], this);
  }
};

PMT.nextIteration = function () {
  this.sentence.destroy();
  this.sentence = null;
  this.choices.map((x) => {
    x.destroy();
  });
  this.choices = [];
  this.loadIteration();
};

export default EDC.Games.PiratesMatchText.Scenes.Main;
